import { render, staticRenderFns } from "./addPlatformBan.vue?vue&type=template&id=e2b88b92"
import script from "./addPlatformBan.vue?vue&type=script&lang=js"
export * from "./addPlatformBan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports